import palor1 from "../assets/palor1.jpg";
import palor2 from "../assets/palor2.jpg";
import palor3 from "../assets/palor3.jpg";
import palor4 from "../assets/palor4.jpg";
import palor5 from "../assets/palor5.jpg";
import palor6 from "../assets/palor6.jpg";
import palor7 from "../assets/palor7.jpg";

export const searchPageDropDown = [
  {
    title: "Price",
    select: ["100,000", "300,000", "500,00", "1,000,000"],
  },
  {
    title: "Bathrooms",
    select: ["2", "3", "4+"],
  },
  {
    title: "Bedrooms",
    select: ["2", "3", "4", "5+"],
  },
  {
    title: "Type",
    select: ["Apartment", "Duplex", "Bungalow", "Townhouse", "Penthouse"],
  },
  {
    title: "Lifestyle",
    select: [
      "Urban Living",
      "Suburban Living",
      "Rural Living",
      "Luxury Living",
      "Eco-Friendly Living",
    ],
  },
  {
    title: "More",
    select: ["Property Size", "Packing Availability", "Furnising Level"],
  },
];

export const propertyData = [
  {
    id: 1,
    img: palor1,
    title: "Ocean Breeze Estate",
    address: "22, Lekki Phase 1, Lagos.",
    bedroom: 4,
    bathroom: 3,
    sittingroom: 2,
    amount: 5000000,
  },
  {
    id: 2,
    img: palor2,
    title: "Sunrise Heights",
    address: "10, Victoria Island, Lagos.",
    bedroom: 3,
    bathroom: 2,
    sittingroom: 1,
    amount: 4500000,
  },
  {
    id: 3,
    img: palor3,
    title: "Harmony Gardens",
    address: "18, Garki Street, Abuja.",
    bedroom: 5,
    bathroom: 4,
    sittingroom: 3,
    amount: 7500000,
  },
  {
    id: 4,
    img: palor4,
    title: "Pinnacle Residences",
    address: "6, Wuse II, Abuja.",
    bedroom: 3,
    bathroom: 2,
    sittingroom: 2,
    amount: 6000000,
  },
  {
    id: 5,
    img: palor5,
    title: "Green Valley Estate",
    address: "12, Oluyole Estate, Ibadan.",
    bedroom: 4,
    bathroom: 3,
    sittingroom: 2,
    amount: 3500000,
  },
  {
    id: 6,
    img: palor6,
    title: "Royal Court",
    address: "9, Maitama District, Abuja.",
    bedroom: 6,
    bathroom: 5,
    sittingroom: 4,
    amount: 12000000,
  },
  {
    id: 7,
    img: palor1,
    title: "Golden Gate Apartments",
    address: "25, Maryland Crescent, Lagos.",
    bedroom: 2,
    bathroom: 1,
    sittingroom: 1,
    amount: 3000000,
  },
  {
    id: 8,
    img: palor1,
    title: "Silver Crest Villas",
    address: "15, Gwarinpa Estate, Abuja.",
    bedroom: 4,
    bathroom: 3,
    sittingroom: 2,
    amount: 8000000,
  },
  {
    id: 9,
    img: palor7,
    title: "Serenity Place",
    address: "5, Akobo Street, Ibadan.",
    bedroom: 3,
    bathroom: 2,
    sittingroom: 1,
    amount: 2500000,
  },
  {
    id: 10,
    img: palor1,
    title: "Tranquil Meadows",
    address: "31, Banana Island, Lagos.",
    bedroom: 5,
    bathroom: 4,
    sittingroom: 3,
    amount: 15000000,
  },
  {
    id: 11,
    img: palor1,
    title: "Cedarwood Court",
    address: "8, Independence Layout, Enugu.",
    bedroom: 3,
    bathroom: 2,
    sittingroom: 1,
    amount: 4000000,
  },
  {
    id: 12,
    img: palor1,
    title: "Amber Hills Estate",
    address: "19, Trans Amadi, Port Harcourt.",
    bedroom: 4,
    bathroom: 3,
    sittingroom: 2,
    amount: 6500000,
  },
];

export const sortMethods = [
  { key: "alphabetical", label: "Alphabetical Order (A-Z)" },
  { key: "reverseAlphabetical", label: "Reverse Alphabetical Order (Z-A)" },
  { key: "numericalAsc", label: "Numerical Order (Low to High)" },
  { key: "numericalDesc", label: "Numerical Order (High to Low)" },
  { key: "dateAsc", label: "Date (Oldest to Newest)" },
  { key: "dateDesc", label: "Date (Newest to Oldest)" },
  { key: "custom", label: "Custom Order" },
  { key: "lengthAsc", label: "By Length (Short to Long)" },
  { key: "lengthDesc", label: "By Length (Long to Short)" },
  { key: "random", label: "Random Order" },
  { key: "priority", label: "By Priority" },
  { key: "boolean", label: "Boolean Value (True/False)" },
  { key: "frequency", label: "By Frequency of Occurrence" },
];

export const propertyTitles = [
  "Title",
  "Price",
  "Property Type",
  "Address",
  "City",
  "State/county",
  "Zip/Postal Code",
  "Country",
  "Property Size",
  "Property ID",
  "Bedrooms",
  "Bathroom",
  "Garage",
  "Air Conditioning",
  "Barbeque",
  "Dryer",
  "Gym",
  "Laundry",
  "Lawn",
  "Microwave",
  "Outdoor Shower",
  "Refrigerator",
  "TV Cable",
  "Swimming Pool",
  "WiFi",
  "Washer",
  "Window Covering",
  "System rating",
];
